import React, { useState, useEffect, useImperativeHandle } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { DigitalVaultAlertsView } from '../../views'
import { AlertService, LocalStorageService } from '../../../services';

const DigitalVaultAlertsAction = (props) => {
    const {
        tabRef,
        documentIdProps,
        goBack,
        t
    } = props;

    const history = useHistory();
    const { search, state } = useLocation();

    const [isLoading, setIsLoading] = useState(true);
    const [showLoadingRequesting, setShowLoadingRequesting] = useState(false);
    const [showErrorRequesting, setShowErrorRequesting] = useState(false);
    const [showCompletedRequesting, setShowCompletedRequesting] = useState(false);
    const [messageError, setMessageError] = useState('');

    const toggleErrorRequesting = (message, time, sendInbox, path) => {
        let sendTo = (path && path !== '') ? path : "/"
        setShowErrorRequesting(true)
        setMessageError(message)

        setTimeout(() => {
            setShowErrorRequesting(false)
            if (sendInbox) {
                history.push(sendTo);
            }
        }, time)
    }

    const [companies, setCompanies] = useState([]);
    const [selectedCompanyId, setSelectedCompanyId] = useState('0');
    const [alerts, setAlerts] = useState([]);
    const [selectedAlert, setSelectedAlert] = useState(null);
    const [currDocumentId, setCurrDocumentId] = useState(null);
    const [viewDetails, setViewDetails] = useState(false);
    const [viewReminders, setViewReminders] = useState(false);
    const [viewDocument, setViewDocument] = useState(false);
    const [viewDeleteDialog, setViewDeleteDialog] = useState(false);

    const url = process.env.REACT_APP_MIFIRMA_API;
    const localStorageService = new LocalStorageService();
    const alertService = new AlertService(url);
    const token = localStorageService.getLocalStorageItem("token").idToken;

    const loadAlerts = async (documentId) => {
        setSelectedAlert(null);
        setViewDetails(false);
        setViewDeleteDialog(false);
        setShowCompletedRequesting(false);
        setIsLoading(true);
        try {
            let response = await alertService.getAllAlertConfigs(token, documentId);
            if (response.statusCode == 200 && response.data) {
                response.data.alerts = response.data.alerts.map(alert => {
                    switch (alert.alertTypeRecurrence.key) {
                        case "Anual":
                            alert.alertTypeRecurrence.key = t("digitalVaultAlertsView.details.annual")
                            break
                        case "Mensual":
                            alert.alertTypeRecurrence.key = t("digitalVaultAlertsView.details.monthly")
                        case "Semanal":
                            alert.alertTypeRecurrence.key = t("digitalVaultAlertsView.details.weekly")
                            break
                        case "Diario":
                            alert.alertTypeRecurrence.key = t("digitalVaultAlertsView.details.diary")
                            break
                        default:
                            break
                    }
                    return alert
                })
                setAlerts(response.data.alerts);
                let companyOptions = response.data.companies;
                // companyOptions = companyOptions.map(item => {
                //     item.alertTypeRecurrence
                // })
                companyOptions.sort((a, b) => a.companyName.toLowerCase().localeCompare(b.companyName.toLowerCase()))
                companyOptions = [{ id: '0', companyName: t("digitalVaultAlertsView.all.companies") }, ...companyOptions]
                setCompanies(companyOptions);
            } else {
                throw new Error(response.data.message || t("digitalVaultAlertsView.errors.general.alerts"))
            }
            setIsLoading(false);
        } catch (e) {
            toggleErrorRequesting(e.message, 4000, true)
        }
    }

    const createUpdateAlert = async (data) => {
        setShowLoadingRequesting(true);
        let fieldsWithError = []

        try {
            const response = await alertService.createAlert(token, data);
            if (response.statusCode == 200) {
                setShowLoadingRequesting(false);
                setShowCompletedRequesting(true);
                setTimeout(() => {
                    loadAlerts(currDocumentId);
                }, 4000);
            } else if (response.statusCode == 420) {
                if (response.data) {
                    if (response.data.invalidFields) {
                        fieldsWithError = response.data.invalidFields || []
                    }
                    if (response.data.missingData) {
                        throw new Error(t("digitalVaultAlertsView.errors.fill.in"))
                    }
                }
                throw new Error(response.message || t("digitalVaultAlertsView.errors.validating"))
            } else {
                throw new Error(response.message || t("digitalVaultAlertsView.errors.creating.alert"))
            }
        } catch (e) {
            setShowLoadingRequesting(false);
            toggleErrorRequesting(e.message, 4000, false);
            return fieldsWithError
        }
    }

    const deleteAlert = async () => {
        if (!selectedAlert || !selectedAlert.id) return;

        setViewDeleteDialog(false);
        setShowLoadingRequesting(true);
        try {
            const response = await alertService.deleteAlert(token, selectedAlert.id);
            if (response.statusCode == 200) {
                setShowLoadingRequesting(false);
                setShowCompletedRequesting(true);
                setTimeout(() => {
                    loadAlerts(currDocumentId);
                }, 4000);
            } else {
                throw new Error(response.message || t("digitalVaultAlertsView.errors.delete.alert"))
            }
        } catch (e) {
            setShowLoadingRequesting(false);
            toggleErrorRequesting(e.message, 4000, false);
        }
    }

    const clearData = () => {
        setCurrDocumentId(null);
    }

    useImperativeHandle(
        tabRef,
        () => ({ clearData }),
        [],
    )

    useEffect(() => {
        let documentId
        const params = new URLSearchParams(search);
        const documentIdParam = params.get("doc");
        documentId = documentIdParam

        if (documentIdProps) {
            documentId = documentIdProps
        } else if (state && state.hadDocumentParam) {
            documentId = state.documentId
            params.append("doc", documentId)
            history.replace({ pathname: `/digital-vault/alerts`, search: params.toString() })
        }

        setCurrDocumentId(documentId);
        loadAlerts(documentId);

        if (state) {
            setSelectedCompanyId(state.selectedCompanyId)
            setSelectedAlert(state.selectedAlert)
            setViewDetails(state.viewDetails)
            setViewDocument(state.viewDocument)
            setViewReminders(state.viewReminders)
        }
    }, [search, documentIdProps])

    return (
        <DigitalVaultAlertsView
            isLoading={isLoading}
            toggleLoadingScreen={setIsLoading}
            showLoadingRequesting={showLoadingRequesting}
            toggleLoadingRequesting={setShowLoadingRequesting}
            showErrorRequesting={showErrorRequesting}
            toggleErrorRequesting={toggleErrorRequesting}
            messageError={messageError}
            showCompletedRequesting={showCompletedRequesting}
            toggleCompletedRequesting={setShowCompletedRequesting}

            companies={companies}
            selectedCompanyId={selectedCompanyId}
            setSelectedCompanyId={setSelectedCompanyId}
            alerts={alerts}
            selectedAlert={selectedAlert}
            documentId={currDocumentId}
            setDocumentId={setCurrDocumentId}
            setSelectedAlert={setSelectedAlert}
            createUpdateAlert={createUpdateAlert}
            deleteAlert={deleteAlert}
            viewDetails={viewDetails}
            setViewDetails={setViewDetails}
            viewReminders={viewReminders}
            setViewReminders={setViewReminders}
            viewDocument={viewDocument}
            setViewDocument={setViewDocument}
            viewDeleteDialog={viewDeleteDialog}
            setViewDeleteDialog={setViewDeleteDialog}
            goBack={goBack}
        />
    )
}

export default DigitalVaultAlertsAction